import { render, staticRenderFns } from "./Rule_Baccarat.vue?vue&type=template&id=02c02322&"
import script from "./Rule_Baccarat.vue?vue&type=script&lang=js&"
export * from "./Rule_Baccarat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports